<!-- 储值卡扣费流水上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportInternalParkingPreCarIn",
                "enterCarLicenseColor": 1,
                "enterCarLicenseNumber": "粤ACCCC7",
                "enterCarLicenseType": 1,
                "enterChannelCode": "channel1",
                "enterChannelCustomCode": "channel1",
                "enterChannelId": 1,
                "enterChargeGroupCode": "",
                "enterTime": "20201016091805",
                "lockKey": "951b25122bc05609693ae5c827cf295453bc8b30",
                "parkCode": "2KKN885S"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台内部车场预进场上报信息到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportInternalParkingPreCarIn",
                precondition: "无",
                fitSystem: "云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'enterCarLicenseNumber', info2: '是', info3: 'String', info4: '进场车牌' },
                        { info1: 'enterChannelId', info2: '否', info3: 'Long', info4: '进场通道ID' },
                        { info1: 'enterChannelCustomCode', info2: '否', info3: 'String', info4: '进场通道编码' },
                        // { info1: 'enterChannelCode', info2: '是', info3: 'String', info4: '进场通道自定义编码' },
                        { info1: 'enterCarLicenseType', info2: '是', info3: 'Integer', info4: '进场车牌类型（0未定义，1蓝牌白字，2黄牌黑字，3白牌，4黑牌白字, 5绿牌）' },
                        { info1: 'enterCarLicenseColor', info2: '是', info3: 'Integer', info4: '进场车牌颜色（0未定义，1蓝色，2黄色，3白色，4黑色，5绿色）' },
                        { info1: 'enterChargeGroupCode', info2: '否', info3: 'String', info4: '月卡规则编号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，yyyyMMddHHmmss' },
                        { info1: 'enterImageArray', info2: '是', info3: 'JSONArray', info4: '智汇云车场，进场图片列表，[{"carImage":"车身图片直接访问url"}]（智汇云支持，上报图片保留90天）' },
                      { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                      { info1: 'fromAreaId', info2: '否', info3: 'String', info4: '来源区域：0为车场外部，其余为区域编码' },
                      { info1: 'toAreaId', info2: '是', info3: 'String', info4: '目的区域：0为车场外部，其余为区域编码' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportInternalParkingPreCarIn.vue